var map = {
	"./autumn-day.ogg": "83a9",
	"./autumn-night.ogg": "524e",
	"./dolmen-day.ogg": "f5a0",
	"./dolmen-night.ogg": "462f",
	"./main.ogg": "b92d",
	"./shop.ogg": "aa8a",
	"./temple-day.ogg": "0c1b",
	"./winter-day.ogg": "ef01",
	"./winter-night.ogg": "5e96"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "63ab";